import { z } from 'zod';

import { FeeId } from '../BrandedIds';
import { InvestorRemittanceSplit } from '../loan/InvestorRemittanceSplit';
import { zodBrandedUuid } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

const FeeUpdate = z.object({
  feeId: zodBrandedUuid<FeeId>(),
  isDeferred: z.boolean(),
  investorRemittanceSplit: InvestorRemittanceSplit.optional(),
});

export const UpdateFeesEvent = BaseLoanEvent.extend({
  type: z.literal('updateFees'),
  feeUpdates: z.array(FeeUpdate).min(1),
  comment: z.string().optional(),
});
export type UpdateFeesEvent = z.infer<typeof UpdateFeesEvent>;
